
import { init, dispose } from 'klinecharts'
let chart = null
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import config from '../components/config'
import {mapState,mapMutations} from 'vuex'
import { coinKLinedata, getTphendlist, stockList, whList, whKdata, getTpmicrolist, getCoinInfo, getCoinTradeInfo, delOptional, addOptional, getOptionalList, stockKdata} from '../service/getdata'
import { scientificNotationToString } from "@/utils/utis";
export default {
data(){
return{
name: "",  //币种名称
type: 1, //合约类型
timeValue: '1mint', //k线时间
dealInfo: {},//交易对信息
subTechnicalIndicatorTypes: ['MA', 'EMA', 'BOLL', 'VOL', 'MACD', 'KDJ', 'RSI'],
typeValue: 'VOL',//图形类型
klinecharts: null,//K线图实例
chart: null,
chartLoading: true, //加载动画
listLoading: true,
paneId: '',
chartData: [], // 图表数据
timer: null,
timeout: null,
timerInfo: null,
orderType: 1, //1委托订单 2最新交易
showLeftList: false,
yxList: [],  //左侧列表
coinInfo: {
wudang: {tick:{bids: [],asks:[]}}
} ,//存放单个代币详情
tradeInfo: [], //最新交易列表
msg: "",
show: false,
isAddOptional: false,
delId: "",
enter: "",
trade_type: '', //1货币 2期货 3股票
flag:'',
pid: "",
code: "",
nation: "",
gpPrice: ""
}
},
components:{
Toast
},
computed:{
...mapState(['token'])
},
created(){

},
mounted() {
this.name = this.$route.query.name
console.log(this.name)
this.type = this.$route.query.type || 1
this.enter = this.$route.query.enter
this.trade_type = this.$route.query.trade_type
this.pid = this.$route.query.pid || ''
this.code = this.$route.query.code || ''
this.nation = this.$route.query.nation || ''



this.SETTOKEN()
this.getOptionalList()
this.$nextTick(()=>{
this.initData()
this.getCoinInfo()
})
},
beforeDestroy() {
this.clearTimer()
dispose('kline')
},
watch: {
isChangeLine(val) {
this.clearTimer()
this.fetchData()
}
},
methods:{
...mapMutations(['SETTOKEN']),
back(){
if(this.enter=='spot'){
this.$router.push(`/pages/spot?name=${this.name}&trade_type=${this.$route.query.trade_type}&code=${this.name}&flag=${this.$route.query.nation}`)
}else if(this.enter=='optional'){
this.$router.push(`/pages/home/index?name=${this.name}`)
}else if(this.enter=='hold'){
this.$router.go(-1)
}else{
this.$router.push('/pages/home/quotes')
}
},
goSpot(){
this.$router.push(`/pages/spot?name=${this.name}&trade_type=${this.$route.query.trade_type}&code=${this.name}&flag=${this.$route.query.nation}&enter=info`)
},
getOptionalList(){
var that = this
this.$Loading()
getOptionalList({token: this.token, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.optionalList = res.data || []
that.optionalList.forEach(ele => {
if(that.trade_type==1 || that.trade_type==2){
if(ele.name == that.name){



that.isAddOptional = true
that.delId = ele.id
}
}else if(that.trade_type==3){
if(ele.gupiao_name == that.name){
that.isAddOptional = true
that.delId = ele.id
}
}
});
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)

}
}.bind(this),function(){
that.$Loading.close()
that.sendMsg("获取数据失败")
})
},
timeChange(time) {


if (typeof time === 'string' && time.includes('-')) {
return time;
}

var date = new Date(time);
var Y = date.getFullYear() + '-';
var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
var D = date.getDate() <10 ? '0'+date.getDate() + ' ' : date.getDate()+' ';
var h = date.getHours() + ':';
var m = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes() ;
var s = date.getSeconds();
return h+m;
},
delOptionalList(){
var that = this
this.$Loading()
delOptional({token: this.token, uid: window.localStorage.getItem("uid"), id: this.delId, trade_type: this.trade_type,flag: this.nation}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.sendMsg(that.$t("取消自选成功"))
that.isAddOptional=false
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)

}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
},
addOptionalList(){
var that = this
this.$Loading()
addOptional({token: this.token, uid: window.localStorage.getItem("uid"), name: this.name, trade_type: this.trade_type, flag: this.nation}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.sendMsg(that.$t("添加成功"))
that.isAddOptional=true
that.getOptionalList()
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)

}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
},
chooseCoin(item){
this.showLeftList = false
if(this.trade_type=='1'){
this.name = item.name
}else if(this.trade_type=='2'){
this.name = item.ptitle
this.pid = item.id
}else{
this.name = item.name
this.code = item.code
}

this.fetchData()
this.getCoinInfo()
},
getYxList(){
var that = this
that.showLeftList = true
this.listLoading = true
this.timeout = setInterval(() => {
if(this.trade_type=='1'){
if(this.type==1){
getTphendlist({ token: this.token}).then(function(res){
var res = res.data;
that.listLoading = false
if(res.status=='1'){

that.yxList = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
}else{
getTpmicrolist({ token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.yxList = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
}
}else if(this.trade_type=='2'){
whList({ token: this.token}).then(function(res){
var res = res.data;
that.listLoading = false
that.yxList = res.data
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
}else{
stockList({token: this.token, type: this.sort, lang: this.nation}).then(function(res){
var res = res.data;
that.listLoading = false
that.yxList = res.data
}.bind(this),function(){
if(isLoading){
that.$Loading.close()
}
console.log("error")
})
}


}, 2000);
},
onClose() {
clearInterval(this.timeout)
this.timeout = null
},

initData() {
chart = init('kline', config);
chart.setOffsetRightSpace(25)
chart.setDataSpace(10)
chart.setPriceVolumePrecision(4, 2)
chart.createTechnicalIndicator('MA', false, { id: 'candle_pane' });
this.paneId = chart.createTechnicalIndicator('VOL');
this.fetchData()
},
fetchData(time) { // 获取数据
clearInterval(this.timer)
this.timer = null
this.getKlineData()
this.chartLoading = true
this.timer = setInterval(() => {
this.getKlineData()

}, 2000);
},
getCoinInfo() { // 获取数据
clearInterval(this.timerInfo)
this.timerInfo = null
this.getIntervalCoin()
this.timerInfo = setInterval(() => {
this.getIntervalCoin()
}, 2000);
},




























getIntervalCoin(){
var that = this
getCoinInfo({ token: this.token,symbol: this.name,  type: this.type, trade_type: this.trade_type,flag:this.nation,}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.coinInfo = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
getCoinTradeInfo({ token: this.token,symbol: this.name, trade_type: this.trade_type,flag:this.nation,}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.tradeInfo = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
getIntervalCoinTimer(){
var that = this
getCoinInfo({ token: this.token,symbol: this.name,  type: this.type, trade_type: this.trade_type,flag:this.nation,}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.coinInfo = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},

getKlineData(){
if(this.trade_type=='1'){
coinKLinedata({symbol: this.name, token: this.token, period: this.timeValue=='1mint'? '1min' : this.timeValue }).then(data => {
if(data.data.status=='1'){
this.chartLoading = false
data = data.data.data
data.map(item => {
item.timestamp = item.time
item.volume = item.vol
})

let str = data[0] ? scientificNotationToString(data[data.length - 1].close.toString()) : ''
let length = 2
if (str.indexOf('.') != -1) {
length = str.split('.')[1].length
}


chart.setPriceVolumePrecision(length, 2)
this.setChartType()
chart.applyNewData(data);
this.$emit('updataLine', false)
}else if(res.status=='-1'){

}

})
}else if(this.trade_type == '3'){
var interval = this.timeValue == '1mint' || this.timeValue == '1min' ? "1" : this.timeValue == '5min' ? "5": this.timeValue == '15min' ? "15": this.timeValue == '30min' ? "30": this.timeValue == '60min' ? "1h" : this.timeValue == '1day' ? "1d": this.timeValue == '1week' ? "1w" : '1m'
stockKdata({symbol: this.name, period:  interval,token: this.token}).then(data => {
var data = data.data.data
if(data.length>0){
this.chartLoading = false

var temp = []
data.map(item => {
if(item){
temp.push({
timestamp: item.d*1000,
open: Number(item.o),
high: Number(item.h),
low: Number(item.l),
close: Number(item.c),
volume:  Number(item.a)
})






}

})
data = temp

let str = data[0] ? scientificNotationToString(data[data.length - 1].close.toString()) : ''
let length = 2
if (str.indexOf('.') != -1) {
length = str.split('.')[1].length
}
chart.setPriceVolumePrecision(length, 2)
this.setChartType()
chart.applyNewData(data);
this.$emit('updataLine', false)
}else if(res.status=='0' && (res.message=='登陆后才能操作' ||res.messag=='登陆后才能进行查看' || data.data.message == '登陆后操作')){
that.$router.push('/pages/relogin')
}

})
}else {
var interval = this.timeValue == '1mint' || this.timeValue == '1min' ? "1" : this.timeValue == '5min' ? "5": this.timeValue == '15min' ? "15": this.timeValue == '30min' ? "30": this.timeValue == '60min' ? "1h" : this.timeValue == '1day' ? "1day": this.timeValue == '1week' ? "1w" : '1m'
whKdata({ interval: interval,token: this.token,pid:this.pid }).then(data => {
var data = data.data.data
if(data.length>0){
this.chartLoading = false
data.map(item => {
item.timestamp = item[0]*1000
item.open =Number(item[1])
item.high = Number(item[3])
item.low = Number(item[4])
item.close = Number(item[2])

})
let str = data[0] ? scientificNotationToString(data[data.length - 1].close.toString()) : ''
let length = 2
if (str.indexOf('.') != -1) {
length = str.split('.')[1].length
}
chart.setPriceVolumePrecision(length, 2)
this.setChartType()
chart.applyNewData(data);
this.$emit('updataLine', false)
}else if(data.data.status=='0' && (data.data.message=='登陆后才能操作' ||data.data.messag=='登陆后才能进行查看' || data.data.message == '登陆后操作')){
that.$router.push('/pages/relogin')
}

})
}

},

setChartType() {
let type = 'area'
if (this.timeValue === '1mint') {
type = 'area'
} else {
type = 'candle_solid'
}
chart.setStyleOptions({
candle: {
type
}
})
},
choiceTime(value) { // 选择周期
this.timeValue = value
clearInterval(this.timer)
this.timer = null
this.fetchData()
},
choiceType(type) { // 选择副线
this.typeValue = type
chart.createTechnicalIndicator(type, false, { id: this.paneId })
},
clearTimer() { //清楚定时器
clearInterval(this.timer)
this.timer = null
clearInterval(this.timeout)
this.timeout = null
clearInterval(this.timerInfo)
this.timerInfo = null
},
sendMsg(content) {
this.msg = content;
this.show = true;
},
},
deactivated() {
this.clearTimer()
}
}



// WEBPACK FOOTER //
// ./src/pages/info.vue